<template>

  <v-container class="align-center flex-row mb-6 pa-0">

    <p class="text-headline-small mb-4">Identificazione</p>


    <!-- <v-switch label="Sconosciuto" density="compact" hide-details color="primary" inset class="mb-6"
        v-model="unknow" @change="unknow_changed" /> -->

          <v-btn-toggle v-model="properties.area" divided color="primary" 
              @update:modelValue="areaChanged"
              variant="outlined" group class="mb-6 d-flex flex-grow-1"
              v-if="runtimeStore.session.user.groups.includes('ufficio_botanico') && !isFormReadOnly" 
              mandatory tile
              >
              <v-btn :value="'pngp'" class="flex-grow-1">
                  PNGP
              </v-btn>
              <v-btn :value="'vda'" class="flex-grow-1">
                  VDA
              </v-btn>
          </v-btn-toggle>

    <flora-division v-model="divisione" @update:model-value="setAvailableFilteredSpecieIfNull" />

    <v-autocomplete :label="`Specie (${species_filtered.length})`" hide-details="" :items="species_filtered" class=""
        item-title="label" v-model="properties.specie_id" @update:modelValue="specieChanged" mandatory
        @focus="focused"
        @click="clicked"
        >
      <template v-slot:append>

        <v-btn size="" :color="letterFilter ? 'deep-orange-darken-3' : 'primary'" v-bind="{ props }"
            class="pa-4">
          <template v-if="letterFilter">
            {{ letterFilter }}
          </template>
          <v-icon v-else>
            {{ letterFilter ? `mdi-alpha-${letterFilter}` : 'mdi-filter' }}
          </v-icon>

          <v-dialog v-model="letterFilterDialog" activator="parent" width="auto" theme="dark">
            <v-card>
              <v-card-text>
                <v-container>
                  <v-row :justify="'center'">
                    <v-btn v-for="letter in alphabet" @click="selectLetter(letter)" class="ma-2 pa-4"
                        color="blue-darken-3" dark :key="letter" size="">
                      {{ letter }}
                    </v-btn>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions class="flex-column">
                <v-btn size="large" variant="elevated" color="blue-darken-3"
                    @click="letterFilter = false; letterFilterDialog = false">

                  <template v-slot:prepend>
                    <v-icon class="ml-2">mdi-filter-off</v-icon>
                  </template>
                  Annulla filtro
                </v-btn>
                <v-btn size="large" variant="outlined" color="white" @click="letterFilterDialog = false"
                    class="mx-0 my-3">

                  <template v-slot:prepend>
                    <v-icon class="ml-2">mdi-chevron-down</v-icon>
                  </template>
                  Indietro</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-btn>
      </template>
    </v-autocomplete>



  </v-container>


  <v-container class="align-center flex-row mb-6 pa-0">

    <v-select v-model="properties.habitat_id" :items="baseData.lookup.habitatflora" label="Habitat" item-title="label"
        hide-details class="mb-6" />

    <v-select v-model="properties.fenologia_id" :items="baseData.lookup.fenologiaflora" label="Fenologia"
        item-title="label" hide-details class="mb-6" />
  </v-container>


    <div class="border-primary pa-3 border-md rounded mb-6">

    <v-switch label="albero-habitat" density="compact" hide-details color="primary" inset
        v-model="properties.ah"
        @change="ah_changed"
      ></v-switch>
    
    <div v-if="properties.ah"  class="mt-6">


      <v-select label="Diametro" v-model="properties.ah_dimensione" hide-details :items="dimensioni_ah"/>
      <p class="mb-4">
        diametro (d) in cm
        circonferenza (c) in cm
        da misurare a 1,3 m di altezza da monte
      </p>


      <v-select label="Epifite" v-model="properties.ah_epifite" hide-details :items="epifite_ah">
        <template #append>
          <v-btn size="" class="pa-4" :color="!switchEpifite ? 'green' : 'lime'" @click="switchEpifite = !switchEpifite"><v-icon>mdi-eye</v-icon></v-btn>
        </template>
      </v-select>
      <p class="mb-4">
        Edera, Clematis vitalba, abbondante muschio o licheni, essudati (no resina), cancri, riscoppi del fusto o scopazzi
      </p>
      <p v-show="switchEpifite" class="mb-4">
        <v-img 
          @click="switchEpifite = false"    
        :src="epifite_img" alt="epifite reference image" />
      </p>
      <v-select label="Caratteristiche" v-model="properties.ah_caratteristiche" hide-details :items="caratteristiche_ah"/>
      <p class="mb-4">
        Sporadicità, isolamento, capitozzatura, biforcazione
      </p>
      <v-select label="Funghi" v-model="properties.ah_funghi" hide-details :items="funghi_ah">
        <template #append>
          <v-btn size="" class="pa-4" :color="!switchFunghi ? 'green' : 'lime'" @click="switchFunghi = !switchFunghi"><v-icon>mdi-eye</v-icon></v-btn>
        </template>
      </v-select>
      <p class="mb-4">
        corpi fungini o gruppi di corpi fungini, diametro (d) > 5cm
      </p>
      <p v-show="switchFunghi" class="mb-4">
        <v-img 
          @click="switchFunghi = false"    
        :src="funghi_img" alt="funghi reference image" />
      </p>
      <v-select label="Cavità e fenditure" v-model="properties.ah_cavita" hide-details :items="cavita_ah">
        <template #append>
          <v-btn size="" class="pa-4" :color="!switchCavita ? 'green' : 'lime'" @click="switchCavita = !switchCavita"><v-icon>mdi-eye</v-icon></v-btn>
        </template>
      </v-select>
      <p class="mb-4">
        Fori di picchio, ferite non rimarginate, cavità, sollevamento corteccia, fenditure
      </p>
      <p v-show="switchCavita" class="mb-4">
        <v-img 
          @click="switchCavita = false"    
        :src="cavita_img" alt="cavita reference image" />
      </p>
      <v-select label="Legno morto" v-model="properties.ah_legno_morto" hide-details :items="legno_morto_ah"/>
      <p class="mb-4">
        Branche di legno morto  con lunghezza > 1 m (d = diametro)
      </p>
      <v-select label="Posizione" v-model="properties.ah_posizione" hide-details :items="posizione_ah"/>
      <p class="mb-4">
        Distanza da sentieri, strade e altre vie di comunicazione (h = altezza albero habitat)
      </p>
      <v-select label="Nidi" v-model="properties.ah_nidi" hide-details :items="nidi_ah">
        <template #append>
          <v-btn size="" class="pa-4" :color="!switchNidi ? 'green' : 'lime'" @click="switchNidi = !switchNidi"><v-icon>mdi-eye</v-icon></v-btn>
        </template>
      </v-select>
      <p class="mb-4">
        Nidi di uccelli o mammiferi
      </p>
      <p v-show="switchNidi" class="mb-4">
        <v-img 
          @click="switchNidi = false"    
        :src="nidi_img" alt="nidi reference image" />
      </p>

    <p class="text-title-large">
      Punti: {{ ah_points }}<br>
      Risultato: {{ ah_points_result }}
    </p>
          

    </div>
    </div>
  <SegnalazioneCommon v-model="properties" />
</template>

<script setup>

import { ref, inject, onMounted, computed, nextTick } from 'vue'
import SegnalazioneCommon from "@/reports/components/SegnalazioneCommon";
import FloraDivision from "@/reports/components/FloraDivision";

import { useBrowserSession } from "@/store/browserSession"
import baseData from '@/assets/catalog/TrackerForms.json'

import epifite_img from "@/assets/img/ah/epifite.png"
import funghi_img from "@/assets/img/ah/funghi.png"
import cavita_img from "@/assets/img/ah/cavita.png"
import nidi_img from "@/assets/img/ah/nidi.png"


// import { useDisplay } from 'vuetify'
// const { mobile } = useDisplay()
import { useRuntimeStore } from "@/store/runtime"

import { useToastsStore } from "@/store/toasts";

const runtimeStore = useRuntimeStore();

const toastsStore = useToastsStore();

const browserSession = useBrowserSession()
const properties = defineModel()

const props = defineProps({
  "isNew": {
    type: Boolean,
    default: false
  },
})

const letterFilterDialog = ref(false)
const letterFilter = ref(false)
const divisione = ref(false)

if (!properties.value?.area){
  properties.value.area = "pngp"
}
// const divisioni = computed(() => {
//   const divisioni = [...baseData.lookup.divisione_flora,]
//   return divisioni
// })
const selectLetter = async (letter) => {
  letterFilter.value = letter;
  letterFilterDialog.value = false
  await nextTick()

  setAvailableFilteredSpecieIfNull()

}

const focused = async (event) => {
  console.log("selecting input by focus")
  event.target.select()
}

const clicked = async (event) => {
  // get input son of target
  const input = event.target.querySelector('input')
  if (input){
    console.log("selecting input by click")
    input.select()
  }
}


const alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('');



const loadDefaults = () => {
  console.log("loadDefaults()")
  if (browserSession.settings.defaults?.[properties.value.model]?.specie_id) {
    properties.value.specie_id = browserSession.settings.defaults[properties.value.model].specie_id
  }

  if (browserSession.settings.defaults?.[properties.value.model]?.area) {
    properties.value.area = browserSession.settings.defaults[properties.value.model].area
  }

  properties.value.habitat_id = null
  properties.value.fenologia_id = null
}


const setAvailableFilteredSpecieIfNull = async () => {

  if (!species_filtered.value.find((item) => item.value == properties.value.specie_id)) {
    if (species_filtered.value.length > 0)
      properties.value.specie_id = species_filtered.value[0].value
    else {

      toastsStore.toast({
        title: 'Filtro specie',
        text: 'Specie non trovata, filtri resettati',
        type: 'error',
        duration: 2000
      })

      letterFilter.value = null
      divisione.value = false
      properties.value.specie_id = 1153
    }
  }


}


// 0 PUNTI: d < 30   /   c < 95
// 1 PUNTI:  31 < d < 60   /   96 < c < 190
// 2 PUNTI: 61 < d < 90   /   191 < c < 290
// 3 PUNTI: 91 < d < 120   /   291 < c < 380
// 4 PUNTI: 121 < d < 150   /    381 < c < 470
// 5 PUNTI: 151 < d < 180   /   471 < c < 565
// 6 PUNTI: > 181   /   > 565

const dimensioni_ah = [
  { value: 1, title: "d < 30 cm / c < 95 cm (0 punti)", points: 0 },
  { value: 2, title: "31 < d < 60 cm / 96 < c < 190 cm (1 punto)", points: 1 },
  { value: 3, title: "61 < d < 90 cm / 191 < c < 290 cm (2 punti)", points: 2 },
  { value: 4, title: "91 < d < 120 cm / 291 < c < 380 cm (3 punti)", points: 3 },
  { value: 5, title: "121 < d < 150 cm / 381 < c < 470 cm (4 punti)", points: 4 },
  { value: 6, title: "151 < d < 180 cm / 471 < c < 565 cm (5 punti)", points: 5 },
  { value: 7, title: ">181 cm / >565 cm (6 punti)", points: 6 },
]




// 2. EPIFITE
// Edera, Clematis vitalba, abbondante muschio o licheni, essudati (no resina), cancri, riscoppi del fusto o scopazzi
// 0 PUNTI: non presenti
// 1 PUNTO: presente
// 2 PUNTI: edera con diametro > 5 cm

const epifite_ah = [
  { value: 1, title: "Non presenti (0 punti)", points: 0 },
  { value: 2, title: "Presenti (1 punto)", points: 1 },
  { value: 3, title: "Edera con diametro > 5 cm (2 punti)", points: 2 },
]
// 3. CARATTERISTICHE
// Sporadicità, isolamento, capitozzatura, biforcazione
// 0 PUNTI: nessuna
// 1 PUNTI: presente
// -1 PUNTI: albero di castagno

const caratteristiche_ah = [
  { value: 1, title: "Nessuna (0 punti)", points: 0 },
  { value: 2, title: "Presente (1 punto)", points: 1 },
  { value: 3, title: "Albero di castagno (-1 punto)", points: -1 },
]


// 4. FUNGHI
// corpi fungini o gruppi di corpi fungini, diametro (d) > 5cm
// 0 PUNTI: nessun corpo fungino
// 1 PUNTI: 1 corpo fungino d > 5cm
// 2 PUNTI: 2 corpi fungini d > 5cm
// 3 PUNTI: 3 o più corpi fungini d > 5cm

const funghi_ah = [
  { value: 1, title: "Nessun corpo fungino (0 punti)", points: 0 },
  { value: 2, title: "1 corpo fungino d > 5cm (1 punto)", points: 1 },
  { value: 3, title: "2 corpi fungini d > 5cm (2 punti)", points: 2 },
  { value: 4, title: "3 o più corpi fungini d > 5cm (3 punti)", points: 3 },
]

// 5. CAVITA' E FENDITURE
// Fori di picchio, ferite non rimarginate, cavità, sollevamento corteccia, fenditure
// 0 PUNTI: nessuna
// 1 PUNTI: posiziona da terra < 50 cm
// 2 PUNTI: posizione 50 < h < 200 cm
// 3 PUNTI: posizione da terra > 200 cm

const cavita_ah = [
  { value: 1, title: "Nessuna (0 punti)", points: 0 },
  { value: 2, title: "Posizione da terra < 50 cm (1 punto)", points: 1 },
  { value: 3, title: "Posizione da terra tra 50 e 200 cm (2 punti)", points: 2 },
  { value: 4, title: "Posizione da terra > 200 cm (3 punti)", points: 3 },
]


// 6. LEGNO MORTO
// Branche di legno morto  con lunghezza > 1 m
// (d = diametro)
// 0 PUNTI: non presente
// 1 PUNTI: solo branche piccole (d < 10 cm)
// 2 PUNTI: fino a 3 branche grandi (d > 10 cm)
// 3 PUNTI: oltre 3 branche grandi

const legno_morto_ah = [
  { value: 1, title: "Non presente (0 punti)", points: 0 },
  { value: 2, title: "Solo branche piccole (d < 10 cm) (1 punto)", points: 1 },
  { value: 3, title: "Fino a 3 branche grandi (d > 10 cm) (2 punti)", points: 2 },
  { value: 4, title: "Oltre 3 branche grandi (3 punti)", points: 3 },
]

// 7. POSIZIONE
// Distanza da sentieri, strade e altre vie di comunicazione
// (h = altezza albero habitat)
// 0 PUNTI: distanza > 1,5 h
// -1 PUNTI: adiacenza sentieri segnalati (< 0,5 h)
// -3 PUNTI: prossimità strade (> 0,5 h < 1,5 h)
// -7 PUNTI: adiacenza strade (< 0,5 h)

const posizione_ah = [
  { value: 1, title: "Distanza > 1,5 h (0 punti)", points: 0 },
  { value: 2, title: "Adiacenza sentieri segnalati (< 0,5 h) (-1 punto)", points: -1 },
  { value: 3, title: "Prossimità strade (> 0,5 h < 1,5 h) (-3 punti)", points: -3 },
  { value: 4, title: "Adiacenza strade (< 0,5 h) (-7 punti)", points: -7 },
]

// 8. NIDI
// Nidi di uccelli o mammiferi
// 0 PUNTI: nessuno
// 1 PUNTI: almeno uno di dimensioni medie (es. cornacchia)
// 2 PUNTI: almeno uno di grandi dimensioni

const nidi_ah = [
  { value: 1, title: "Nessuno (0 punti)", points: 0 },
  { value: 2, title: "Almeno uno di dimensioni medie (es. cornacchia) (1 punto)", points: 1 },
  { value: 3, title: "Almeno uno di grandi dimensioni (2 punti)", points: 2 },
]





const ah_points = computed(() => {
  let points = 0
  const dimensione = dimensioni_ah.find((item) => item.value == properties.value.ah_dimensione)
  points += dimensione ? dimensione.points : 0
  const epifite = epifite_ah.find((item) => item.value == properties.value.ah_epifite)
  points += epifite ? epifite.points : 0
  const caratteristiche = caratteristiche_ah.find((item) => item.value == properties.value.ah_caratteristiche)
  points += caratteristiche ? caratteristiche.points : 0
  const funghi = funghi_ah.find((item) => item.value == properties.value.ah_funghi)
  points += funghi ? funghi.points : 0
  const cavita = cavita_ah.find((item) => item.value == properties.value.ah_cavita)
  points += cavita ? cavita.points : 0
  const legno_morto = legno_morto_ah.find((item) => item.value == properties.value.ah_legno_morto)
  points += legno_morto ? legno_morto.points : 0
  const posizione = posizione_ah.find((item) => item.value == properties.value.ah_posizione)
  points += posizione ? posizione.points : 0
  const nidi = nidi_ah.find((item) => item.value == properties.value.ah_nidi)
  points += nidi ? nidi.points : 0
  return points
})

const ah_points_result = computed(() => {
  const points = ah_points.value

  if (points < 2) {
    return "Albero standard"
  }
  else if (points >= 2 && points < 4) {
    return "Albero con potenzialità per un futuro lontano"
  }
  else if (points >= 4 && points < 6) {
    return "Albero d'avvenire"
  }
  else if (points >= 6 && points < 8) {
    return "Albero habitat"
  }
  else if (points >= 8) {
    return "Albero habitat di particolare interesse conservazionistico"
  }
})

const switchEpifite = ref(false)
const switchFunghi = ref(false)
const switchCavita = ref(false)
const switchNidi = ref(false)


const ah_changed = () => {
  if (!properties.value.ah) {
    delete properties.value.ah_dimensione
    delete properties.value.ah_epifite
    delete properties.value.ah_caratteristiche
    delete properties.value.ah_funghi
    delete properties.value.ah_cavita
    delete properties.value.ah_legno_morto
    delete properties.value.ah_posizione
    delete properties.value.ah_nidi
  }
}


const specieChanged = async () => {


  await nextTick()

  await setAvailableFilteredSpecieIfNull()

  browserSession.settings.defaults[properties.value.model].specie_id = properties.value.specie_id
  setLabel()

}




const species_filtered = computed(() => {
  // debugger
  // const emptyArray = []


  // const species_filtered_no_unknow = species_filtered_raw.filter((item) => {
  //   return !item.label.toLowerCase().includes("sconosciuto")
  // })

  let sfiltered = baseData.lookup.flora  // copy


  console.log("filter by area: " + properties.value.area)

  sfiltered = sfiltered.filter((item) => {
    return item?.[`presenza_${properties.value.area}`] === true
  })

  if (divisione.value) {
    console.log("filter by divisione: " + divisione.value)

    sfiltered = sfiltered.filter((item) => {
      // console.log(item)
      return item?.divisione == divisione.value
    })
  }

  if (letterFilter.value) {
    sfiltered = sfiltered.filter((item) => {
      return item.label.toLowerCase().startsWith(letterFilter.value)
    })

  }


  if (!sfiltered.includes(properties.value.specie_id)) {
    // la specie non è contenuta nella lista filtrata
    if (sfiltered.length == 0) {
      properties.value.specie_id = null
    }
  }



  return sfiltered

})


const setLabel = () => {
  const actualSpecie = species_filtered.value.find((item) => item.value == properties.value.specie_id)

  if (actualSpecie) {
    properties.value.label = actualSpecie.label.replace("AAA ", "")
  }
  else {
    properties.value.label = "no taxon"
  }

}



const areaChanged = async () => {
  console.log("areaChanged")
  browserSession.settings.defaults[properties.value.model].area = properties.value.area
  setAvailableFilteredSpecieIfNull()

}

const isFormReadOnly = ref(false) 

onMounted(() => {
  const svf = inject(Symbol.for("vuetify:form"), { isReadonly: false })
  isFormReadOnly.value = svf.isReadonly.value

  // console.log("mounted")
  if (props.isNew) {
    loadDefaults()
  }

  // if (!properties.value.specie_id) {
  //   unknow.value = true
  // }
  setLabel()
})

</script>
